// extracted by mini-css-extract-plugin
export default {"line":"Line_line__G3W0N","or":"Line_or__njhTU","gray200":"Line_gray200__HX1K+","gray100":"Line_gray100__qU2kP"};